import { mergeCustomJewelryConfig } from '../content/siteCopyHelpers';

export { CUSTOM_JEWELRY_DEFAULTS } from './customJewelryDefaults';

export function getCustomJewelryConfig(storeCopy) {
  return mergeCustomJewelryConfig(storeCopy?.custom_jewelry);
}

export function isCustomJewelryEnabled(storeCopy) {
  return getCustomJewelryConfig(storeCopy).enabled !== false;
}

/** @param {'shop'|'nav'|'footer'|'card'|'gift_finder'} placement */
export function isCustomJewelryLinkVisible(storeCopy, placement) {
  const cfg = getCustomJewelryConfig(storeCopy);
  if (!cfg.enabled) return false;
  switch (placement) {
    case 'shop':
      return cfg.show_on_shop !== false;
    case 'nav':
      return cfg.show_in_nav !== false;
    case 'footer':
      return cfg.show_in_footer !== false;
    case 'gift_finder':
      return cfg.show_on_gift_finder !== false;
    default:
      return false;
  }
}

/** @param {'shop'|'nav'|'footer'|'card'} placement */
export function customJewelryLinkLabel(storeCopy, placement = 'shop') {
  const cfg = getCustomJewelryConfig(storeCopy);
  if (placement === 'nav' || placement === 'footer') return cfg.nav_label;
  return cfg.shop_button_label;
}
